
import React, { Fragment } from "react";
import request from '../../../api';
import { Button, Dialog, DialogContent, DialogContentText, TextField, DialogActions, DialogTitle, Select, MenuItem, InputLabel } from '@material-ui/core'
import { Exam } from "../../../interfaces/examiner/Exam";
import { loadStripe } from "@stripe/stripe-js";
import { Payment } from "../../../interfaces/teacher/Payment,";
import { Question } from "../../../interfaces/shared/Question";
import { Paper } from "../../../interfaces/shared/Paper";

interface Props {
    onClose:()=>void
    onDelete:(paper:Paper)=>void
    paper:Paper
}

interface State {
}

export default class PaperDeleteDialog extends React.Component<Props, State> {

    constructor(props:Props) {

        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <div>
            <Dialog open={true} onClose={this.props.onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Delete Paper</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you wish to delete {this.props.paper.title}?</p>             
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onDelete} color="secondary">
                            Yes
                        </Button>
                        <Button onClick={this.onClose} color="secondary">
                            No
                        </Button>
                    </DialogActions>                    
            </Dialog>
            </div>
        );
    }

    onDelete = () => {
        this.props.onDelete(this.props.paper)
    }

    onClose = () => {
        this.props.onClose()
    }

}